import React from 'react'
import Player from 'video.js/dist/types/player'
import videojs from 'video.js'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import VideoJS from './VideoJS'

const HelpTutorialComponent = () => {
  const playerRef = React.useRef<Player | null>(null)

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    aspectRatio: '16:9',
  }

  const handlePlayerReady = (player: Player) => {
    playerRef.current = player
    player.on('waiting', () => {
      videojs.log('player is waiting')
    })

    player.on('dispose', () => {
      videojs.log('player will dispose')
    })
  }

  return (
    <Container fluid={true}>
      <Row className="gx-5 my-5">
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>SMART FLOW Monitoring Overview</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                How SMART FLOW monitoring assists you.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/SMART%20FLOW%20Avator%20Company%20Overview%20.mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Main Dashboard Features</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                A quick walkthrough of the key dashboard tools ,so you can navigate with confidence.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/SMART FLOW Main Page overview .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Device Status</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Learn how to check device performance at a glance, signal, battery and connectivity.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/Device Status .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>ESG Reporting</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Learn how to generate water sustainability reports in seconds.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/ESG and Water Sustainability Reporting .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="gx-5 my-5">
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Features and Hourly Usage</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Explore the full dashboard feature set, including hourly water usage across all locations.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/How to navigate performance and Hourly Usage .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Total spent on Water </Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Understand the real cost of water to your business.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/Total Spent .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Invoice for Actual Water Consumption</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Learn how to invoice tenants accurately based on their actual water consumption.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/Invoice Function _Water Supply Bill_.mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Water Bill Validation</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Learn how to validate your utility water bills and quickly spot discrepancies.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/Water Usage and Water Bill Validation .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="gx-5 my-5">
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>SMART FLOW Water Alerts</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Understand what each water alert means and the best next step to take.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/Understanding your water Alerts .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}>
          <Card className="h-100">
            <Card.Header>Account Management</Card.Header>
            <Card.Body>
              {/*<Card.Title>Card title</Card.Title>*/}
              <Card.Text>
                Learn how to add or remove users and set up who receives alerts.
              </Card.Text>
              <VideoJS
                options={{
                  ...videoJsOptions,
                  sources: [{
                    src: 'https://smartflowftpstorage1.blob.core.windows.net/video/Account Admin for adding users .mp4',
                    type: 'video/mp4',
                  }]
                }}
                onReady={handlePlayerReady}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3}></Col>
        <Col xl={3}></Col>
      </Row>
    </Container>
  )
}

export default HelpTutorialComponent